"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../../baseSchema");
class DatahubViewHomeService extends baseSchema_1.BaseSchema {
    constructor() {
        super();
        this.system = baseSchema_1.Systems.HOTMART_CLUB;
        this.action = baseSchema_1.ActionsName.VIEW_MODERATION;
        this.componentName = baseSchema_1.ComponentNames.HOME;
        this.screenName = baseSchema_1.ScreenNames.NOT_APP_EVENT;
        this.arrivedFrom = baseSchema_1.ArrivedFrom.MEMBERSHIP_ADMIN;
        this.pushKind = baseSchema_1.PushKind.NOT_PUSH_EVENT;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            system: this.system,
            action: this.action,
            componentName: this.componentName,
            screenName: this.screenName,
            arrivedFrom: this.arrivedFrom,
            pushKind: this.pushKind
        };
    }
}
exports.default = DatahubViewHomeService;
